<template>
  <div
    class="groupon-module"
    :style="{ background: background, padding: padding + 'px' }"
  >
    <div
      class="flex flex-between item-center"
      v-if="titleVisible"
      :style="{ color }"
    >
      <div class="title">{{ title }}</div>
      <div class="view-more">
        查看更多
        <span class="hmicon hmicon icon-youjiantou"></span>
      </div>
    </div>
    <div class="second-title" :style="{ color }" v-if="secTitleVisible">
      {{ secTitle }}
    </div>
    <div class="groupon-list" :class="listClass">
      <div class="groupon-item flex" v-for="(v, i) in grouponList" :key="i">
        <div class="img-wrapper">
          <img
            :src="v.spuMainPic"
            :class="{ borderRadius }"
            class="img"
            :widthFix="listClass !== 'list'"
          />
        </div>
        <div class="info-wrapper flex-1 flex flex-column flex-between">
          <div>
            <div class="goods-name text-overflow" :class="{ titleBold }">
              {{ v.spuName }}
            </div>
            <!-- <div v-if="listClass !== 'grid-scroll'">
							<span class="btn round tag"  :style="{background: storeStyle.baseColor}" >已拼{{v.goodsSellNum}}件</span>
						</div> -->
          </div>
          <div class="flex flex-between item-center">
            <div class="team-info">
              <div class="openteam-number">
                <span class="team" :style="{ color: storeStyle.baseColor }"
                  >{{ v.openteamNumber }}人团</span
                >
                <span class="symbol" :style="{ color: storeStyle.baseColor }"
                  >￥<span class="price">{{
                    v.jointeamProfitPrice
                  }}</span></span
                >
              </div>
              <div class="single-price">
                单价买<span class="">￥{{ v.retailPrice }}</span>
              </div>
            </div>
            <div v-if="listClass === 'list'">
              <button
                :style="{ background: storeStyle.baseColor }"
                class="btn round"
              >
                去拼团
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {
    type: {
      type: String,
      default: "1"
    },
    title: {
      type: String,
      default: ""
    },
    titleVisible: {
      type: Boolean,
      default: true
    },
    secTitle: {
      type: String,
      default: ""
    },
    secTitleVisible: {
      type: Boolean,
      default: true
    },
    fillBgType: {
      type: String,
      default: "custom"
    },
    color: {
      type: String,
      default: "#2b2b2b"
    },
    bg: {
      type: String,
      default: "#ffffff"
    },
    grouponList: {
      type: Array,
      default: () => []
    },
    titleBold: {
      type: Boolean,
      default: false
    },
    borderRadius: {
      type: Boolean,
      default: false
    },
    padding: {
      type: Number,
      default: 15
    }
  },
  components: {},
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["storeStyle"]),
    listClass() {
      let className = "";
      switch (this.type) {
        case "1":
          className = "grid";
          break;
        case "2":
          className = "list";
          break;
        case "3":
          className = "grid-scroll";
          break;
        default:
          break;
      }
      return className;
    },
    background() {
      if (this.bg.indexOf("http") > -1) {
        return `url(${this.bg})`;
      } else {
        return this.bg;
      }
    }
  },
  watch: {},
  created() {},
  mounted() {},
  methods: {}
};
</script>
<style lang="scss" scoped>
.groupon-module {
  .view-more {
    font-size: 13px;
    opacity: 0.7;
    .iconfont {
      font-size: 12px;
    }
  }

  .title {
    font-weight: bold;
    font-size: 16px;
  }

  .second-title {
    font-size: 14px;
    margin: 10px 0;
    opacity: 0.7;
    word-break: break-all;
  }

  .list {
    .groupon-item {
      background: #fff;
      padding: 10px;
      border-radius: 6px;
      margin-bottom: 10px;
    }

    .img-wrapper {
      width: 110px;
      height: 110px;
      flex-shrink: 0;
      .img {
        width: 100%;
        height: 100%;
      }
    }

    .info-wrapper {
      width: 64%;
    }
  }

  .grid {
    display: flex;
    flex-wrap: wrap;
    .groupon-item {
      display: flex;
      flex-direction: column;
      width: 49%;
      background: #fff;
      margin-bottom: 10px;
      &:nth-child(odd) {
        margin-right: 2%;
      }

      .single-price {
        margin-bottom: 10px;
      }
    }
  }

  .grid-scroll {
    display: flex;
    white-space: nowrap;
    overflow-x: scroll;
    overflow-y: hidden;
    .groupon-item {
      display: flex;
      flex-direction: column;
      width: 40%;
      background: #fff;
      margin-right: 10px;
      flex-shrink: 0;
      .openteam-number {
        margin-bottom: 7px;
        margin-top: 10px;
      }
      .single-price {
        margin-bottom: 10px;
      }
    }
  }

  .borderRadius {
    border-radius: 6px;
  }

  .info-wrapper {
    padding: 0 10px;
  }

  .titleBold {
    font-weight: bold;
  }

  .btn {
    border-radius: 30px;
    color: #fff;
    border: 1px solid transparent;
    height: 29px;
    line-height: 29px;
    font-size: 14px;
  }

  .btn.tag {
    font-size: 10px;
    padding: 0 5px;
  }

  .single-price {
    color: #999;
    font-size: 12px;
  }

  .openteam-number {
    margin-bottom: 10px;
  }

  .team {
    font-size: 12px;
  }

  .symbol {
    font-size: 12px;
    margin-left: 10px;
    .price {
      font-size: 14px;
    }
  }
}
</style>
